import { createFeatureSelector, createSelector } from '@ngrx/store';
import { TimeEntryGridConfig } from './timeEntryGridConfig.state';

export const getTimeEntryGridConfigState = createFeatureSelector<TimeEntryGridConfig >('timeEntryGridConfig');

export const getTimeEntryGridConfig = createSelector(
  getTimeEntryGridConfigState,
  (state) => state.timeEntryGridConfig
);
